<template>
  <div class="login-card__login-card">
    <div class="login-card__title-box">
      <h5 class="login-card__title">{{ trans.get('auth.card.login.header') }}</h5>
      <!--            <p class="login-card__title-desc"> {{ trans.get('auth.card.login.subheader') }}</p>-->
    </div>


    <a :href="zRoute('login.provider', 'google')" class="button button--google">
      <img src="../../../images/logo/google.svg" alt="Google button">
      {{ trans.get('auth.card.welcome.google_button') }}
    </a>
    <a :href="zRoute('login.provider', 'facebook')" class="button button--fb">
      <i class="demo-icon icon-facebook-circle"> </i>
      {{ trans.get('auth.card.welcome.facebook_button') }}
    </a>

    <p class="login-card__title-desc"> {{ trans.get('auth.card.welcome.or') }} </p>

    <validation-observer ref="form" v-slot="{ handleSubmit }">
      <div>
        <validation-provider name="response_error" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
        <validation-provider name="email" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
        <validation-provider name="phone" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
        <validation-provider name="name" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group">
          <validation-provider name="login" rules="required" v-slot="{ errors }" mode="eager">
            <label for="login"></label>
            <input
              type="text"
              id="login"
              class="input-text input-text__underline"
              v-model="form.login"
              :placeholder="loginPlaceholder"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="form-group">
          <validation-provider name="password" rules="required" v-slot="{ errors }" mode="eager">
            <div class="input-group is-invalid">
              <div class="input-group-append">
                <label for="password"></label>
                <input
                  :type="passwordInputType"
                  id="password"
                  class="form-control input-text input-text__underline"
                  v-model="form.password"
                  :placeholder="trans.get('auth.card.fields.password')"
                >
                <button type="button" class="button__password-eye" @click="switchPasswordVisibility"><i class="demo-icon icon-show" aria-hidden="true"></i></button>
              </div>
            </div>
            <span class="text-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="login-card__buttons-inline">
          <div class="checkbox-standard text-left">
            <label>
              <input type="checkbox" id="checkbox" v-model="form.remember">
              <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2"></span>
              <span class="desc desc--color-secondary"> {{ trans.get('auth.card.login.stay_logged_in') }}</span>
            </label>
          </div>
          <button type="button" class="button button__link--cta text-nowrap" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.login.forgot_password') }}</button>
        </div>

        <button type="submit" class="button__auth">{{ trans.get('auth.card.welcome.log_in') }}</button>

        <button type="button" class="button button__link--cta text-nowrap" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.login.forgot_password') }}</button>
      </form>
    </validation-observer>

    <button type="button" class="button button__link button--back" @click="swapComponent('auth-welcome-card')">
      <i class="demo-icon icon-left"> </i>
      {{ trans.get('auth.card.buttons.back') }}
    </button>

  </div>
</template>
<script>
import AuthGoBackMixin from './../../../../js/front/components/Auth/AuthGoBackMixin';

export default {
  props: ['swapComponent'],
  mixins: [AuthGoBackMixin],
  data: () => ({
    form: {
      email: '',
      password: '',
      remember: false,
    },
    passwordInputType: 'password',
  }),
  computed: {
    loginPlaceholder: function () {
      return this.globals.profile.enable_name_login ?
        'Email oder Nickname'
        : this.trans.get('auth.card.fields.login');
    }
  },
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      axios.post(zRoute('login'), this.form)
        .then((response) => {
          if (response.data.status === 'success') {
            window.location.href = zRoute('home');
          }
        })
        .catch((error) => {
          const errors = error.response.data.errors;

          if (error.response.status === 422) {
            this.$refs.form.setErrors(errors);
          } else {
            this.$refs.form.setErrors({ response_error: [this.trans.get('auth.error')] });
          }
        });
    },
    async refreshCSRFToken() {
      axios.get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    goBack() {
      this.swapComponent('auth-welcome-card');
    }
  },
  activated() {
    this.refreshCSRFToken();
  },
};
</script>
<style scoped>
</style>